import { Activity, Cpu, Shield, Zap } from "lucide-react";

const cards = [
  { key: "status", label: "System", icon: Shield },
  { key: "active_users", label: "Active Users", icon: Activity },
  { key: "devices_online", label: "Devices", icon: Zap },
  { key: "automations_active", label: "Automations", icon: Cpu },
];

export const SystemStatus = ({ status, health }) => (
  <section className="jarvis-panel" data-testid="system-status-panel">
    <div className="jarvis-panel-header">
      <div>
        <p className="jarvis-eyebrow">Realtime system overview</p>
        <h2 className="jarvis-title" data-testid="system-status-title">System Status</h2>
      </div>
      <div className="jarvis-chip" data-testid="system-status-chip">{status?.status || "offline"}</div>
    </div>
    <div className="jarvis-status-grid">
      {cards.map(({ key, label, icon: Icon }) => (
        <div className="jarvis-metric" key={key} data-testid={`system-status-metric-${key}`}>
          <div>
            <span>{label}</span>
          <strong>{status?.[key] ?? status?.counts?.[key] ?? "—"}</strong>
          </div>
          <Icon size={18} />
        </div>
      ))}
    </div>
    <div className="jarvis-detail-grid" data-testid="system-health-detail-grid">
      <div className="jarvis-detail-box" data-testid="health-kernel-latency">
        <span>Kernel latency</span>
        <strong>{health?.kernel_latency_ms ?? "—"} ms</strong>
      </div>
      <div className="jarvis-detail-box" data-testid="health-event-queue-size">
        <span>Event queue</span>
        <strong>{health?.event_queue_size ?? "—"}</strong>
      </div>
      <div className="jarvis-detail-box" data-testid="health-device-connectivity">
        <span>Device connectivity</span>
        <strong>{health?.device_connectivity?.online_devices ?? 0}/{health?.device_connectivity?.total_devices ?? 0}</strong>
      </div>
    </div>
  </section>
);